import React from 'react';
import { Provider } from 'urql';

import { useUrqlClient } from './useUrqlClient';

export type Props = { readonly children: React.ReactNode };

export const UrqlProvider = (props: Props) => {
  const client = useUrqlClient();

  if (!client) return null; // avoids TS error from pre-init `null` state

  return <Provider value={client}>{props.children}</Provider>;
};
